import { format } from 'date-fns';

export const formatDate = (milliseconds) => {
    return format(new Date(milliseconds), 'dd/MM/yyyy')
}
